"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _Tooltip = _interopRequireDefault(require("react-bootstrap/Tooltip"));

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/OverlayTrigger"));

require("./TaskCallout.css");

var _CompletedContext = require("../CompletedContext");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CalloutHotspot = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CalloutHotspot, _Component);

  var _super = (0, _createSuper2.default)(CalloutHotspot);

  function CalloutHotspot(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CalloutHotspot);
    _this = _super.call(this, props);
    _this.state = {
      selected: false
    };
    _this.onMouseIn = _this.onMouseIn.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseOut = _this.onMouseOut.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CalloutHotspot, [{
    key: "onMouseIn",
    value: function onMouseIn() {
      if (!this.state.selected) {
        this.setState({
          selected: true
        });
      }

      this.props.onMouseInteract();
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut() {
      if (this.state.selected) {
        this.setState({
          selected: false
        });
      }

      this.props.onMouseInteract();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
        placement: "right",
        key: this.props.index,
        overlay: /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
          id: "task-callouts-tooltip-" + this.props.index
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "tooltip-inner-inner",
          id: "task-callouts-tooltip-inner-" + this.props.index,
          role: "tabpanel",
          tabIndex: "0",
          "aria-expanded": this.state.selected,
          hidden: !this.state.selected,
          "aria-labelledby": "task-callouts-tab-" + this.props.index
        }, this.props.content))
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "callout",
        id: "task-callouts-tab-" + this.props.index,
        tabIndex: "0",
        role: "tab",
        "aria-selected": this.state.selected ? "true" : "false",
        "aria-controls": "task-callouts-tooltip-inner-" + this.props.index,
        "aria-label": this.props.label,
        "aria-labelledby": "task-callouts-tooltip-inner-" + this.props.index,
        style: this.props.style,
        onMouseEnter: this.onMouseIn,
        onMouseOver: this.onMouseIn,
        onPointerDown: this.onMouseIn,
        onGotPointerCapture: this.onMouseIn,
        onPointerOver: this.onMouseIn,
        onPointerEnter: this.onMouseIn,
        onTouchStart: this.onMouseIn,
        onFocus: this.onMouseIn,
        onMouseLeave: this.onMouseOut,
        onMouseOut: this.onMouseOut,
        onPointerOut: this.onMouseOut,
        onTouchEnd: this.onMouseOut,
        onBlur: this.onMouseOut,
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 39) {
            // Right
            var index = _this2.props.index + 1;

            if (index >= _this2.props.totalItems) {
              index = 0;
            }

            document.getElementById("task-callouts-tab-" + index).focus();
          }

          if (e.keyCode === 37) {
            // Left
            var _index = _this2.props.index - 1;

            if (_index < 0) {
              _index = _this2.props.totalItems - 1;
            }

            document.getElementById("task-callouts-tab-" + _index).focus();
          }
        }
      }));
    }
  }]);
  return CalloutHotspot;
}(_react.Component);

var TaskCallout = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(TaskCallout, _Component2);

  var _super2 = (0, _createSuper2.default)(TaskCallout);

  function TaskCallout(props) {
    var _this3;

    (0, _classCallCheck2.default)(this, TaskCallout);
    _this3 = _super2.call(this, props);
    _this3.state = props.state || {};

    if (!_this3.state.initialized) {
      _this3.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this3.state.completed = false;
      _this3.state.completed_hotspots = [];
      _this3.state.completed_hotspots.length = props.hotspots.length;
    }

    _this3.onMouseInteract = _this3.onMouseInteract.bind((0, _assertThisInitialized2.default)(_this3));
    return _this3;
  }

  (0, _createClass2.default)(TaskCallout, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i]; // Keep our stored state synchronized

        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      console.log("task mount", this.state); // Notify the parent of our completion status

      this.context.registerTask(function (id) {
        _this4.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "onMouseInteract",
    value: function onMouseInteract(k) {
      this.setState(function (state, props) {
        var hotspots = state.completed_hotspots.slice();
        hotspots[k] = true;
        var completed = true;

        for (var i = 0; i < props.hotspots.length; ++i) {
          if (!hotspots[i]) {
            completed = false;
          }
        }

        return {
          completed_hotspots: hotspots,
          completed: completed
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        className: "task task-callout " + (this.props.className || ""),
        role: "tablist",
        style: this.props.style,
        "aria-describedby": "task-callout-details"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: this.props.picture,
        alt: this.props.alt || ""
      }), /*#__PURE__*/_react.default.createElement("details", {
        className: "sr-only",
        id: "task-callout-details"
      }, this.props.details), this.props.hotspots.map(function (v, k) {
        return /*#__PURE__*/_react.default.createElement(CalloutHotspot, {
          key: k,
          onMouseInteract: function onMouseInteract() {
            return _this5.onMouseInteract(k);
          },
          style: v.style,
          content: v.content,
          index: k,
          totalItems: _this5.props.hotspots.length,
          label: v.label
        });
      }));
    }
  }]);
  return TaskCallout;
}(_react.Component);

exports.default = TaskCallout;
TaskCallout.contextType = _CompletedContext.CompletedContext;